import React, {useRef, useState} from "react";
import {InboundAdminProps} from "../Outbound/AdminProps";
import {AuthUser} from "aws-amplify/auth";
import {useUserManager} from "../hooks/useUserManager";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {useIonToast} from "@ionic/react";
import {FilterMatchMode} from "primereact/api";
import FileSaver from "file-saver";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {jsPDF} from "jspdf";
import xlsx from "xlsx";
import moment from "moment";

export interface UserAdminProps {
    user: AuthUser;
}

export const UserListView: React.FC<UserAdminProps> = ({user}) => {

    const dt = useRef(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
  
    //'purchaseOrderNumber', 'city', 'state'
    const [filters, setFilters] = useState({
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        orderID: {value: null, matchMode: FilterMatchMode.CONTAINS},
        city: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        state: {value: null, matchMode: FilterMatchMode.STARTS_WITH}
    });
    const cols: any[] = [
        {title: "ORDER #", dataKey: "orderID"},
        {title: "CITY", dataKey: "city"},
        {title: "STATE", dataKey: "state"},
        {title: "HOT LOAD", dataKey: "hotLoad"},
        {title: "Tarped", dataKey: "tarpRequired"},
        {title: "MILES", dataKey: "miles"},
        {title: "BOOK NOW RATE", dataKey: "bookNowRate"}
    ];
    const [compState, setCompState] = useState<{
        onlyBids: boolean,
        curData: any[],
        toDelete: any[],
        showToast: boolean,
        toastMessage: string
    }>({
        showToast: false,
        toastMessage: "",
        onlyBids: false,
        curData: [],
        toDelete: []
    });
    const {users} = useUserManager(user);
    const exportPdf = () => {
        const exportColumns = cols;
        const doc: any = new jsPDF("landscape", "px");
        doc.autoTable(exportColumns, users);
        doc.save('products.pdf');
    };
    const exportExcel = () => {
        let dataMapped: any[] = users.map(i => {
            return {}
        });
        dataMapped.unshift({});
        const worksheet = xlsx.utils.json_to_sheet(dataMapped, {skipHeader: true});
        xlsx.utils.sheet_add_aoa(worksheet, [["ORDER #", "CITY", "STATE", "HOT LOAD", "MILES", "BOOK NOW RATE"]]); //heading: array of arrays
        const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
        saveAsExcelFile(excelBuffer, 'products');

    };
    const saveAsExcelFile = (buffer: any, fileName: any) => {

        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);

    };
    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        let _filters: any = {...filters};

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const emailTemplate = (rowData: any) => {
        return <><span>{rowData['email']}</span></>;
    }
    const userStateTemplateTemplate = (rowData: any) => {
        return <><span>{rowData['status']}</span></>;
    }
    const createdAtTemplate = (rowData: any) => {
        return <><span>{moment(rowData['createdAt']).format("MM/DD/YYYY")}</span></>;
    }
    const updatedAtTemplate = (rowData: any) => {
        return <><span>{moment(rowData['lastAccessed']).format("MM/DD/YYYY")}</span></>;
    }
    const header = (
        <div className="flex gap-2 items-center p-ai-center export-buttons">
            <Button type="button" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success p-mr-2"
                    data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportPdf} className="p-button-warning p-mr-2"
                    data-pr-tooltip="PDF"/>
            <div className={"w-40"}>Users Count: {users.length} </div>
            <div className={"w-full text-right"}>
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search"/>
            </div>
        </div>
    );
    return <div>
        <div>User List</div>
        <DataTable header={header} ref={dt} value={users}
                   filters={filters}
                   globalFilterFields={['email', 'status']}
                   currentPageReportTemplate="{totalRecords} total trucks" paginator rows={10}>
            <Column field="email" header="Email" sortable filter body={emailTemplate}></Column>

            <Column field="status" header="User Status" sortable filter body={userStateTemplateTemplate}></Column>
            <Column field="createdAt" header="Created At" sortable filter body={createdAtTemplate}></Column>
            <Column field="lastAccessed" header="Updated At" sortable filter body={updatedAtTemplate}></Column>
        </DataTable>
    </div>
}